import React, { useState } from 'react';

const TermsAndConditionsModal = () => {
    const [checked, setChecked] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [showModal, setShowModal] = useState(true);

    const handleChange = event => {
        setChecked(event.target.checked);
    }

    const handleClick = event => {
        event.preventDefault();
        setDisabled(true);
        setShowModal(false);
        fetch('/actions/auth/policy')
            .then(response => response.json())
            .then(data => {
                console.log(data);
            });
    }

    return showModal ? (
        <div className="terms-and-conditions-modal">
            <div className="content">
                <div className="checkbox">
                    <input disabled={disabled} type="checkbox" name="agree-checkbox" id="agree-checkbox" className="checkbox__input" onChange={handleChange} />
                    <label htmlFor="agree-checkbox" className="checkbox__label">
                        <span className="required">
                            * You must check this box to continue.
                        </span>

                        <br />

                        By checking this box, you consent to receive emails from Cutter Associates. You may unsubscribe
                        from these emails at any time, and your current email preferences will remain unaffected.
                        Additionally, by checking this box, you certify that you are an employee or staff contractor in
                        a staff augmentation role with the firm that holds the Cutter Membership. You agree to comply
                        with the firm's Cutter Membership Agreement, which strictly prohibits sharing access to Cutter
                        research, as well as virtual or in-person events, with any vendor, contractor, consultant, or
                        third-party provider associated with your firm. For further information, please consult the
                        <a href="/privacy" target="_blank">Privacy Policy</a> and <a href="/terms-of-use" target="_blank">Terms of Use Policy</a>.
                    </label>
                </div>

                <button className="button" disabled={!checked || disabled} onClick={handleClick}>
                    Submit
                </button>
            </div>
        </div>
    ) : '';
}

export default TermsAndConditionsModal;